import { create } from "zustand";

// Persisted preference for which dashboard a dual-role (teacher + manager) user
// sees at "/". Ignored for single-role users (their view is forced by perms).
const STORAGE_KEY = "dashboardView";

const useDashboardViewStore = create((set) => ({
  preference: localStorage.getItem(STORAGE_KEY) || "school",
  setPreference: (v) => {
    localStorage.setItem(STORAGE_KEY, v);
    set({ preference: v });
  },
}));

export default useDashboardViewStore;
